<template>
<div>
  <div>
    <div data-wizard-type="step-content" data-wizard-state="current">
      <div class="row">
        <div class="col-xl-12 py-5">
          <div class="row">
            <div class="col-xl-9 pb-0"><h5>Thèmes</h5></div>
            <div class="col-xl-3 text-end pb-0">
              <a class="btn btn-light-danger" color="primary" @click.stop="dialog = true">
                {{ !!themeSelected && themeSelected.length > 0 ? "Modifier le thème" : "Ajouter un thème" }}
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 py-0">
              <div class="form-group">
                <div class="pa-3">
                  <div class="text-left font-weight-medium mb-2 pl-4" style="font-size: 14px;">
                    Nom des thèmes sélectionnés
                  </div>
                  <v-treeview
                    :items="themeSelectedHierarchy"
                    item-key="id"
                    item-text="title"
                    dense
                    hoverable
                  ></v-treeview>
                </div>
              </div>
            </div>
          </div>


          <!-- <div class="row">
            <div class="col-xl-12 py-0">
              <div class="form-group">
                <v-simple-table class="elevation-0">
                  <template v-slot:default>
                    <thead>
                      <tr class="pt-0">
                        <th class="text-left pl-4">Nom des parcours liés aux thèmes sélectionnés</th>
                      </tr>
                    </thead>
                    <div v-for="course in themeSelected[0].courses" :key="course.id">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="py-2 pl-4">{{ course.title }}</div>
                      </div>
                      <v-divider class="my-0"></v-divider>
                    </div>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </div> -->



          <!-- Modal pour choisir le thème  -->
          <v-dialog v-model="dialog" max-width="700">
            <v-card max-width="700">
              <v-card-title class="headline d-flex justify-content-center px-1">Veuillez sélectionner un thème à ajouter à la liste</v-card-title>
                <v-card-text>
                  <v-treeview
                    v-model="themeSelected"
                    :items="themes"
                    item-value="title"
                    item-text="title"
                    selectable
                    background-color="#f5b83e"
                    return-object
                  ></v-treeview>
                </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="orange darken-1" text @click="dialog = false">Annuler</v-btn> -->
                <v-btn color="blue darken-1" text @click="updateUserRightTheme"> Valider la sélection </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </div>

  <!-- Display Parcours -->
    <div class="py-5">
      <h5>Parcours</h5>
      <v-simple-table fixed-header dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Nom des parcours</th>
            </tr>
          </thead>
          <tbody>
            <tr class="py-0" v-for="course in courses" :key="course.id">
              <td style="font-size:13px">
                {{ course.title }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
</div>  
</template>
<script>

import Api from "@/core/services/api.service";
import userParentThemes from "@/core/utils/userParentThemes";

export default {
  name: "userRightTreeviewThemeTable",

//On retrouve ici le v-model: formData envoyé par le parent. J'ai décidé de le renommer "userRight"
// + d'infos voir v-model custom, ou nested v-model
  model: {
    prop: "userRight",
    event: "input",
  },
  
  props: {
    userRight: Object,
  },

  data: () => ({
    dialog: false,
    themes: [],
    themeSelected: [],
    courses: [],
  }),

  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },

    themeSelectedHierarchy() {
      if (!this.themeSelected || this.themeSelected.length === 0 || !this.themes) {
        return [];
      }
      
      var flattenThemes = (themes) => {
        var flat = {};
        var traverse = (items) => {
          items.forEach(item => {
            flat[item.id] = item;
            if (item.children && item.children.length > 0) {
              traverse(item.children);
            }
          });
        };
        traverse(themes);
        return flat;
      };
      
      var allThemesMap = flattenThemes(this.themes);
      var hierarchyMap = {};

      this.themeSelected.forEach(selectedTheme => {
        var findParent = (themeId) => {
          for (let theme of Object.values(allThemesMap)) {
            if (theme.children && theme.children.some(child => child.id === themeId)) {
              return theme;
            }
          }
          return null;
        };
        
        var buildPath = (theme) => {
          var path = [theme];
          let parent = findParent(theme.id);
          while (parent) {
            path.unshift(parent);
            parent = findParent(parent.id);
          }
          return path;
        };
        
        var path = buildPath(selectedTheme);
        
        let current = hierarchyMap;
        path.forEach((theme, index) => {
          if (!current[theme.id]) {
            current[theme.id] = {
              id: theme.id,
              title: theme.title,
              children: {}
            };
          }
          if (index < path.length - 1) {
            current = current[theme.id].children;
          }
        });
      });
      
      var convertToArray = (obj) => {
        return Object.values(obj).map(item => ({
          id: item.id,
          title: item.title,
          children: Object.keys(item.children).length > 0 ? convertToArray(item.children) : undefined
        }));
      };
      
      return convertToArray(hierarchyMap);
    }
  },

  watch: {
    themeSelected(){
      if (Array.isArray(this.themeSelected)) {
        this.refreshCourses();
      } else {
        this.courses = [];
      }
    }
  },

  mounted() {
    this.themeSelected = this.userRight.themes
    Api.get("themes")
    .then(themes => {
      this.themes = userParentThemes(themes.data["hydra:member"])
      this.refreshCourses()
    });
  },

  methods: {
    updateUserRightTheme() {
      this.$emit("updateUserRightTheme", this.themeSelected);
      this.dialog = false;
    },
    refreshCourses() {
      this.courses = Array.isArray(this.themeSelected) 
        ? this.themeSelected.flatMap(t => t.courses || []) 
        : [];
    }
  },
};
</script>
